import PageLayout from "components/shared/pageLayout/PageLayout";
import Redeem from "components/redeem/Redeem";

function Inwisselen() {
    return (
        <PageLayout
            slug="inwisselen"
            title="Lees! Cadeaukaart inwisselen"
            description="Bekijk het overzicht van fysieke winkels en webshops waar je jouw Lees! Cadeaukaart kunt besteden."
        >
            <Redeem />
        </PageLayout>
    );
}

export default Inwisselen;
